import slice, { setBillingInfo } from './billing.slice';
export { setBillingInfo };
export default slice.reducer;
